import { FotoAgrupada } from "../assets";
import styles from "../style";
import { motion } from "framer-motion";

const Features = () => {
  return (
    <section id="features" className={`${styles.paddingY} max-w-7xl mx-auto w-full`}>
      <div className="flex flex-col mb-12 text-center px-6">
        <motion.span 
          initial={{ opacity: 0, y: 10 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-secondary font-bold tracking-[0.3em] uppercase mb-4 text-xs"
        >
          Innovación y Detalle
        </motion.span>
        <motion.h2 
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-[40px] font-poppins font-bold text-darkBlue leading-[1.2]"
        >
          Análisis Técnico del Sistema
        </motion.h2>
      </div>

      <motion.div 
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.8 }}
        className="w-full px-6"
      >
        <div className="relative overflow-hidden rounded-3xl border border-slate-100 bg-white shadow-xl group">
          <img 
            src={FotoAgrupada} 
            alt="Innovación VAE"
            className="w-full h-auto object-contain transition-transform duration-1000 group-hover:scale-[1.02]"
          />
          {/* subtle overlay to blend with white theme if needed, but the user wants it "grande de punta a punta" */}
          <div className="absolute inset-0 pointer-events-none border-[12px] border-white/5 rounded-3xl" />
        </div>
      </motion.div>
    </section>
  );
};

export default Features;
